import { defineMessages } from 'react-intl';

export const paymentProcessMessages = defineMessages({
  paymentErrorTitle: {
    id: 'payment_process.error.title',
    defaultMessage: 'Your payment information could not be saved',
    description: 'Title displayed on payment error page',
  },
  paymentErrorDescription: {
    id: 'payment_process.error.description',
    defaultMessage:
      'If you encounter any technical problems, please do not hesitate to contact us\u000aat the following address: <b>support@algoan.com</b>',
    description: 'Description displayed on payment error page',
  },
  paymentPendingTitle: {
    id: 'payment_process.pending.title',
    defaultMessage: 'We are processing your information...',
    description: 'Title displayed on payment pending page',
  },
  paymentPendingDescription: {
    id: 'payment_process.pending.description',
    defaultMessage: 'Please wait.',
    description: 'Description displayed on payment pending page',
  },
  paymentSignUpTitle: {
    id: 'payment_process.sign_up.title',
    defaultMessage: 'Welcome to the Algoan Dashboard',
    description: 'Title displayed on payment sign up page',
  },
  paymentSignUpDescription: {
    id: 'payment_process.sign_up.description',
    defaultMessage:
      'First of all, we invite you to enter your billing information\u000aso that you can take full advantage of the solution.\u000a\u000aYou will be redirected to our payment partner Stripe.',
    description: 'Description displayed on payment sign up page',
  },
});
